import { gql } from '@apollo/client';

export const CHANGE_PAYMENT_PLAN_MUTATION = gql`
  mutation ChangePaymentPlan($data: UpdatePlanInput!) {
    updatePaymentPlan(data: $data)
  }
`;
